import axios from 'axios';
import config from '../helpers/configProvider';

let root =
  window.location.protocol +
  '//' +
  window.location.hostname +
  (window.location.port ? ':' + window.location.port : '') +
  (config.getEnv(config.enum.VUE_APP_BASE_PATH) || '');

export default () => {
  return axios.create({
    baseURL: config.getEnv(config.enum.VUE_APP_API_SERVICE_URL) || root,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  });
};
